/* sx-swipe (15 Oct 2026, hidden redesign theme): product cards on every page except the homepage
   let you scroll through the piece's photos. Swipe on phones; arrows on hover and trackpad sideways
   scroll on computers. The hover float on the image is kept. Undo: remove the sx-swipe script line
   in snippets/sx-fixes.liquid. */
(function () {
  if (window.__sxSwipe) return; window.__sxSwipe = 1;
  var css = ''
    + '.sx-swc .card__inner{position:relative;z-index:2}'
    + '.sx-swc .card__inner .card__media{z-index:2}'
    + '.sx-swc .card__inner>.card__content{position:relative;z-index:3;pointer-events:none}'
    + '.sx-swc .sx-lp{z-index:4}.sx-swc .sx-qa{z-index:5}'
    + '.sx-swr{position:absolute;inset:0}'
    + '.sx-sw{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain}'
    + '.sx-sw::-webkit-scrollbar{display:none}'
    + '.sx-sw__s{position:relative;flex:0 0 100%;height:100%;scroll-snap-align:start;scroll-snap-stop:always;display:block}'
    + '.sx-sw__s img{position:absolute;inset:0;width:100%;height:100%;-webkit-user-drag:none;user-select:none;animation:sxFloat 3s infinite;animation-play-state:paused}'
    + '.card-wrapper .card:hover .sx-sw__s img{animation-play-state:running}'
    + '.sx-sw__b{position:absolute;top:50%;z-index:2;width:3.2rem;height:3.2rem;margin-top:-1.6rem;padding:0;border:0;background:rgba(255,255,255,.85);opacity:0;transition:opacity .2s ease;display:flex;align-items:center;justify-content:center}'
    + '.sx-sw__b i{width:.8rem;height:.8rem;border-top:1px solid #000;border-right:1px solid #000}'
    + '.sx-sw__b--p{left:.8rem}.sx-sw__b--p i{transform:translateX(.15rem) rotate(-135deg)}'
    + '.sx-sw__b--n{right:.8rem}.sx-sw__b--n i{transform:translateX(-.15rem) rotate(45deg)}'
    + '.sx-sw__b[disabled]{visibility:hidden}'
    + '@media (hover:hover) and (pointer:fine){.card-wrapper:hover .sx-sw__b{opacity:1}}'
    + '@media (hover:none),(pointer:coarse){.sx-sw__b{display:none}}'
    + '.sx-sw__d{display:none!important}'
    + '.sx-sw__d span{width:1.4rem;height:1px;background:rgba(0,0,0,.25);transition:background .2s}'
    + '.sx-sw__d span.on{background:#000}'
    + '@keyframes sxFloat{0%{transform:translateY(0)}45%{transform:translateY(-8px)}100%{transform:translateY(0)}}'
    + '@media (prefers-reduced-motion:reduce){.sx-sw{scroll-behavior:auto}.sx-sw__s img{animation:none}}';
  var st = document.createElement('style'); st.id = 'sx-swipe'; st.textContent = css; document.head.appendChild(st);

  var W = [360, 533, 720, 940], FIT = '';
  function srcset(u) {
    return W.map(function (w) { return u.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ');
  }

  function build(m) {
    if (m.__sx) return; m.__sx = 1;
    var urls = (m.getAttribute('data-sx-imgs') || '').split(/\s+/).filter(Boolean);
    var href = m.getAttribute('data-sx-url');
    var box = m.querySelector('.media'); var first = box && box.querySelector('img');
    if (urls.length < 2 || !box || !first || !href) return;
    var card = m.closest('.card-wrapper'); if (!card) return;
    // sx-speed-05: read the photo fit once for all cards; reading it per card forced a style pass each time
    var fit = FIT || (FIT = getComputedStyle(first).objectFit || 'cover');
    var sizes = first.getAttribute('sizes') || '(min-width: 990px) 25vw, 50vw';
    var title = first.getAttribute('alt') || '';
    var tr = document.createElement('div'); tr.className = 'sx-sw';
    urls.forEach(function (u, i) {
      var a = document.createElement('a'); a.className = 'sx-sw__s'; a.href = href; a.tabIndex = -1;
      a.setAttribute('aria-hidden', 'true'); a.draggable = false;
      var img;
      if (i === 0) { img = first; img.removeAttribute('style'); }
      else {
        // sx-speed-02: extra photos get their address later (see wake below), so the page's first load only fetches the first photo of each card
        img = document.createElement('img'); img.loading = 'lazy'; img.decoding = 'async';
        img.setAttribute('data-sx-src', u); img.sizes = sizes; img.alt = title; img.draggable = false;
      }
      img.style.objectFit = fit;
      a.appendChild(img); tr.appendChild(a);
    });
    [].slice.call(box.querySelectorAll('img')).forEach(function (x) { if (x !== first) x.remove(); });
    var wr = document.createElement('div'); wr.className = 'sx-swr'; wr.appendChild(tr); box.appendChild(wr);
    var p = document.createElement('button'), n = document.createElement('button');
    p.type = n.type = 'button'; p.className = 'sx-sw__b sx-sw__b--p'; n.className = 'sx-sw__b sx-sw__b--n';
    p.setAttribute('aria-label', 'Previous photo'); n.setAttribute('aria-label', 'Next photo');
    p.innerHTML = n.innerHTML = '<i></i>';
    var d = document.createElement('div'); d.className = 'sx-sw__d'; d.setAttribute('aria-hidden', 'true');
    urls.forEach(function () { d.appendChild(document.createElement('span')); });
    wr.appendChild(p); wr.appendChild(n); wr.appendChild(d);
    function idx() { return Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); }
    function sync() {
      var i = idx(); p.disabled = i <= 0; n.disabled = i >= urls.length - 1;
      [].forEach.call(d.children, function (s, k) { s.classList.toggle('on', k === i); });
    }
    function go(k, e) {
      e.preventDefault(); e.stopPropagation();
      tr.scrollTo({ left: (idx() + k) * tr.clientWidth, behavior: 'smooth' });
    }
    p.addEventListener('click', function (e) { go(-1, e); });
    n.addEventListener('click', function (e) { go(1, e); });
    var t; tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    card.classList.add('sx-swc');
    // sx-speed-05: a new card always starts on photo 1, so set the arrows and dots without measuring the layout
    p.disabled = true; n.disabled = urls.length < 2; d.children[0].classList.add('on');
    var woke = false;
    function wake() {
      if (woke) return; woke = true;
      [].forEach.call(tr.querySelectorAll('img[data-sx-src]'), function (x) {
        var u = x.getAttribute('data-sx-src'); x.removeAttribute('data-sx-src'); x.srcset = srcset(u); x.src = u;
      });
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { card.addEventListener(ev, wake, { passive: true, once: true }); });
    tr.addEventListener('scroll', wake, { passive: true, once: true });
    p.addEventListener('click', wake); n.addEventListener('click', wake);
    idle(wake);
  }
  // after the page has finished loading and the browser is free, fetch the rest of the photos anyway so swiping stays instant
  var loaded = document.readyState === 'complete';
  if (!loaded) window.addEventListener('load', function () { loaded = true; });
  function idle(fn) {
    function later() { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(fn, { timeout: 4000 }); }
    if (loaded) setTimeout(later, 1500); else window.addEventListener('load', function () { setTimeout(later, 3000); });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); build(e.target); } });
  }, { rootMargin: '400px 0px' }) : null;
  function scan(root) {
    [].forEach.call((root || document).querySelectorAll('.card__media[data-sx-imgs]'), function (m) {
      if (m.__sxq) return; m.__sxq = 1; io ? io.observe(m) : build(m);
    });
  }
  function start() {
    scan();
    var q = 0; // sx-speed-02: rescan at most once per frame instead of on every DOM change
    new MutationObserver(function (ms) {
      if (q) return;
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { q = requestAnimationFrame(function () { q = 0; scan(); }); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
